
  import { defineComponent, PropType } from 'vue';

  import { TDashboardRegionFilter } from '@/modules/ves/types/regionDashboards';

  import {
    REGION_DASHBOARDS_VES_ACTIONS_NAME,
    REGION_DASHBOARDS_VES_GETTERS_NAME,
  } from '../../../store/regionDashboards/name';
  import { TDashboardsIndicatorCardsConfig } from '../dashboards-indicator-cards/types';
  import DashboardsIndicatorCardsWithModals from '../dashboards-indicator-cards-with-modals/DashboardsIndicatorCardsWithModals.vue';
  import { TModalsConfig } from '../dashboards-indicator-cards-with-modals/types';

  export default defineComponent({
    name: 'RegionDashboardsIndicatorCards',
    components: {
      DashboardsIndicatorCardsWithModals,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionFilter>,
        required: true,
      },
    },
    data(): {
      cardsConfig: TDashboardsIndicatorCardsConfig;
      modalsConfig: TModalsConfig;
    } {
      return {
        cardsConfig: {
          action: REGION_DASHBOARDS_VES_ACTIONS_NAME.getIndicatorCards,
          getter: REGION_DASHBOARDS_VES_GETTERS_NAME.getIndicatorCards,
        },
        modalsConfig: {
          eventsCountByTypes: {
            action: REGION_DASHBOARDS_VES_ACTIONS_NAME.getEventsCountByTypes,
            getter: REGION_DASHBOARDS_VES_GETTERS_NAME.getEventsCountByTypes,
          },
          agreementsCountByTypes: {
            action: REGION_DASHBOARDS_VES_ACTIONS_NAME.getAgreementsCountByTypes,
            getter: REGION_DASHBOARDS_VES_GETTERS_NAME.getAgreementsCountByTypes,
          },
        },
      };
    },
  });
